// Block Version Configuration
// This file provides a simple interface to the version management system

// Import the version manager that coordinates between different version configs
import { 
    getBlocksForVersion as getBlocksFromManager, 
    getAllBlocksForBackwardCompatibility as getAllBlocksFromManager,
    getVersionedBlockName as getVersionedBlockNameFromManager,
    getAvailableVersions,
    isVersionSupported
} from './blockVersions/versionManager';

/**
 * Get blocks for a specific Snap version
 * Falls back to the latest available version if the requested version doesn't exist
 * 
 * @param {string} snapVersion - The Snap version (e.g., "2026.1.0")
 * @returns {Object} Complete block configuration for all categories
 */
export function getBlocksForVersion(snapVersion) {
    return getBlocksFromManager(snapVersion);
}

/**
 * Get all blocks for backward compatibility
 * This ensures all block versions are registered with Blockly
 */
export function getAllBlocksForBackwardCompatibility() {
    return getAllBlocksFromManager();
}

/**
 * Get the correct versioned block name for programmatic block creation
 * 
 * The function will automatically resolve to the correct version based on snapVersion:
 * - "rest_service" + "2026.0.0" → "rest_service"
 * - "rest_service" + "2026.1.0" → "rest_service_V2"
 * - "rest_service" + "2026.2.0" → "rest_service_V2" if 2026.2.0 still uses the rest_service_V2 block
 * 
 * @param {string} baseBlockName - The BASE block name WITHOUT version suffix (e.g., "rest_service", NOT "rest_service_V2")
 * @param {string} snapVersion - The Snap version (e.g., "2026.1.0")
 * @returns {string} The versioned block name to use (e.g., "rest_service_V2")
 */
export function getVersionedBlockName(baseBlockName, snapVersion) {
    return getVersionedBlockNameFromManager(baseBlockName, snapVersion);
}

/**
 * Additional utility functions
 */
export { getAvailableVersions, isVersionSupported };
